import router from '@/router';
import format from 'date-fns/format';

const date = new Date();
const dayMillisecond = 1000 * 60 * 60 * 24;
const today = format(date, 'YYYY-MM-DD');
const start7 = format(new Date(date.getTime() - 7 * dayMillisecond), 'YYYY-MM-DD');
const start30 = format(new Date(date.getTime() - 30 * dayMillisecond), 'YYYY-MM-DD');
const start90 = format(new Date(date.getTime() - 90 * dayMillisecond), 'YYYY-MM-DD');

export default {
  state:
  {
    appBreadcrumb: [],
    listTypeAll: { label: '全部', value: '' },
    filterByDay:
      [
        { label: '近7天', value: [start7, today] },
        { label: '近30天', value: [start30, today] },
        { label: '近90天', value: [start90, today] },
      ],
    filterByTrendIncrease:
      [
        { label: '今日', value: 'Day' },
        { label: '本周', value: 'Week' },
        { label: '本月', value: 'Month' },
        { label: '今年', value: 'Year' },
      ],
    filterByTrend: [{ label: '近7天', value: [start7, today] }, { label: '近30天', value: [start30, today] }],
    userTrendList: [],
    totalFans: 0,
    totalPayMember: 0,
    totalRegMember: 0,
    warningList: [],
    shopJoinedTotal: 0,
    shopJoined: 0,
    shopJoinedHistory: 0,
    couponPopularList: [],
    optimizationHomeList: [],
    optimizationList: [],
    activityGroupRankList: [],
    memberRadarList: [],
    appRankList: [],
    channelRankList: [],
    couponGetRankList: [],
    couponEffectiveRankList: [],
    couponSaleRankList: [],
  },
  getters: {},
  mutations:
  {
    setAppBreadcrumb(state: any, list: Array<any>) {
      state.appBreadcrumb = [...(list || [])];
    },
    setUserTrend(state: any, list: Array<any>) {
      state.userTrendList = [...(list || [])];
    },
    setTotalUser(state: any, { fansNum, memberNum, payerNum }: any) {
      state.totalFans = fansNum;
      state.totalPayMember = payerNum;
      state.totalRegMember = memberNum;
    },
    setWarningList(state: any, { list, total }: any) {
      state.warningList = [...(list || [])];
    },
    setWarningPageList(state: any, { list, total }: any) {
      state.warningList = [...(list || []), { total }];
    },
    setShopJoined(state: any, { maShopAll, maActivityShopHis, maActivityShopCurrent }: any) {
      state.shopJoinedTotal = maShopAll;
      state.shopJoined = maActivityShopCurrent;
      state.shopJoinedHistory = maActivityShopHis;
    },
    setCouponPopular(state: any, list: Array<any>) {
      state.couponPopularList = [...(list || [])];
    },
    setOptimizationHomeList(state: any, { list, total }: any) {
      state.optimizationHomeList = [...(list || [])].slice(0, 2);
    },
    setOptimizationList(state: any, { list, total }: any) {
      state.optimizationList = [...(list || []), { total }];
    },
    setActivityGroupRankList(state: any, list: Array<any>) {
      state.activityGroupRankList = [...(list || [])];
    },
    setMemberRadarList(state: any, list: Array<any>) {
      state.memberRadarList = [...(list || [])];
    },
    setAppRankList(state: any, list: Array<any>) {
      state.appRankList = [...(list || [])];
    },
    setChannelRankList(state: any, list: Array<any>) {
      state.channelRankList = [...(list || [])];
    },
    setCouponGetList(state: any, list: Array<any>) {
      state.couponGetRankList = [...(list || [])];
    },
    setCouponEffectiveList(state: any, list: Array<any>) {
      state.couponEffectiveRankList = [...(list || [])];
    },
    setCouponSaleList(state: any, list: Array<any>) {
      state.couponSaleRankList = [...(list || [])];
    },
  },
  actions:
  {
    async getUserTrend({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('HOME_USER_TREND', params);
      success && commit('setUserTrend', success.data);
      return { error, success };
    },
    async getTotalUser({ commit }: any) {
      const { error, success }: any = await router.app.$request('HOME_USER_TOTAL');
      success && commit('setTotalUser', success.data);
      return { error, success };
    },
    async getMainTrend({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('HOME_MARKETING_TREND', params);
      return { error, success };
    },
    async getWarningList(
      { commit }: any,
      params: any = { pageNum: 1, pageSize: 9999, noticeDate: router.app.$format(new Date()) },
    ) {
      const { error, success }: any = await router.app.$request('HOME_WARNING', params);
      success && commit('setWarningList', success.data);
      return { error, success };
    },
    async getWarningPageList({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('HOME_WARNING', params);
      success && commit('setWarningPageList', success.data);
      return { error, success };
    },
    async getShopJoined({ commit }: any) {
      const { error, success }: any = await router.app.$request('HOME_SHOP_JOINED');
      success && commit('setShopJoined', success.data);
      return { error, success };
    },
    async getCouponPopular({ commit }: any, params: any = {}) {
      const { error, success }: any = await router.app.$request('HOME_COUPON_POPULAR', params);
      success && commit('setCouponPopular', success.data);
      return { error, success };
    },
    async getOptimizationList({ commit }: any, params: any = { pageNum: 1, pageSize: 9999 }) {
      const { error, success }: any = await router.app.$request('HOME_OPTIMIZATION', params);
      success && params.pageNum == 1 && commit('setOptimizationHomeList', success.data);
      success && commit('setOptimizationList', success.data);
      return { error, success };
    },
    async getActivityGroupRank({ commit }: any, params: any = {}) {
      params.limit = 5;
      const { error, success }: any = await router.app.$request('HOME_ACTIVITY_RANK', params);
      success && commit('setActivityGroupRankList', success.data);
      return { error, success };
    },
    async getMeberRadar({ commit }: any, params: any = {}) {
      const { error, success }: any = await router.app.$request('HOME_MEMBER_RADAR', params);
      success && commit('setMemberRadarList', success.data);
      return { error, success };
    },
    async getAppRank({ commit }: any, params: any = {}) {
      params.limit = 5;
      const { error, success }: any = await router.app.$request('HOME_APP_RANK', params);
      success && commit('setAppRankList', success.data);
      return { error, success };
    },
    async getChannelRankChart({ commit }: any, params: any = {}) {
      params.limit = 5;
      const { error, success }: any = await router.app.$request('HOME_CHANNEL_STATISTICS', params);
      return { error, success };
    },
    async getChannelRankList({ commit }: any, params: any = {}) {
      params.limit = 5;
      const { error, success }: any = await router.app.$request('HOME_CHANNEL_RANK', params);
      success && commit('setChannelRankList', success.data);
      return { error, success };
    },
    async getCouponRankList({ commit }: any, params: any = {}) {
      params.limit = 10;
      params.rankType = 1;
      success && commit('setCouponGetList', []);
      var { error, success }: any = await router.app.$request('HOME_COUPON_RANK', params);
      success && commit('setCouponGetList', success.data);
      params.rankType = 2;
      success && commit('setCouponEffectiveList', []);
      var { error, success }: any = await router.app.$request('HOME_COUPON_RANK', params);
      success && commit('setCouponEffectiveList', success.data);
      params.rankType = 3;
      success && commit('setCouponSaleList', []);
      var { error, success }: any = await router.app.$request('HOME_COUPON_RANK', params);
      success && commit('setCouponSaleList', success.data);
      return { error, success };
    },
    async getAccountRelationEntity({ commit }: any, params: any = {}) {
      const { error, success }: any = await router.app.$request('ACCOUNT_RELATION_LIST', params);
      return { error, success };
    },
  },
};
